import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Close",
  "use": "icon-Close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Close\">\r\n<rect x=\"4.79883\" y=\"16.6797\" width=\"16.8\" height=\"2.4\" rx=\"1.2\" transform=\"rotate(-45 4.79883 16.6797)\" fill=\"currentColor\" />\r\n<rect x=\"6.49609\" y=\"4.80029\" width=\"16.8\" height=\"2.4\" rx=\"1.2\" transform=\"rotate(45 6.49609 4.80029)\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol